<div [class]="isContrast() ? 'ngkit-search-box--dark' : 'ngkit-search-box'" role="search" aria-label="Search component">
  <i class="pi ngkit-search-box__search-icon" aria-hidden="true"></i>

  @if (!isSubmitting()) {
    @if (!useAutocomplete()) {
      <!-- Text Input Mode -->
      <input
        type="search"
        class="pi ngkit-search-box__input"
        pInputText
        [ngModel]="searchQuery()"
        (ngModelChange)="updateSearchQuery($event)"
        (keydown.enter)="onSearchSubmit()"
        [placeholder]="placeholder()"
        appendTo="body"
        aria-label="Search items"
        aria-describedby="search-instructions"
      />
      @if (searchQuery()) {
        <i
          tabindex="0"
          class="pi ds-ngkit ds-ngkit-cross ngkit-search-box__close-icon"
          (click)="clearSearch()"
          role="button"
          aria-label="Clear search"
          (keydown.enter)="clearSearch()"
          (keydown.space)="clearSearch(); $event.preventDefault()"
        ></i>
      }
    } @else {
      <!-- AutoComplete Mode -->
      <p-autoComplete
        [ngModel]="searchQuery()"
        [suggestions]="filteredItems()"
        (completeMethod)="filterItems($event)"
        (onSelect)="onItemSelect($event)"
        (keydown.enter)="onSearchSubmit()"
        [placeholder]="placeholder()"
        appendTo="body"
        class="ngkit-search-box__autocomplete"
        aria-label="Search items"
        aria-expanded="true"
        aria-autocomplete="list"
        optionLabel="name"
      >
        <ng-template let-item #item>
          <div class="ngkit-search-box__autocomplete-item">
            <span
              class="ngkit-search-box__autocomplete-type"
              [innerHTML]="highlightMatches(item.type, searchQuery())"
              aria-hidden="true"
            ></span>
            <span aria-hidden="true">: </span>
            <span
              class="ngkit-search-box__autocomplete-name"
              [innerHTML]="highlightMatches(item.name, searchQuery())"
            ></span>
          </div>
        </ng-template>
      </p-autoComplete>
    }

    @if (searchQuery() && useAutocomplete()) {
      <i
        tabindex="0"
        class="pi ds-ngkit ds-ngkit-cross ngkit-search-box__close-icon"
        (click)="clearSearch()"
        role="button"
        aria-label="Clear search"
        (keydown.enter)="clearSearch()"
        (keydown.space)="clearSearch(); $event.preventDefault()"
      ></i>
    }
  } @else {
    <!-- Submitting State - Spinner Icon -->
    <i class="pi pi-spin pi-spinner ngkit-search-box__spinner"></i>
  }
</div>
